import useAdverts from "../../hooks/useAdverts";
import { PLACEMENT, APP } from "@asosteam/asos-web-adverts-sdk";
import Advert from "@asosteam/asos-web-adverts-display";
import { useIsInStockContext } from "../../context/isInStock/IsInStockContext";
import { useStockPrice } from "../../context/stockPrice/StockPriceContext";
import { getFirstVariant, getPreselectedVariant } from "../../utils/product";
import styles from "./AdvertBanner.scss";
import { usePreviousBackInStock } from "../../context/backInStock/BackInStockContext";
import CriteoSpotLightAdvert from "../criteoSpotLightAdvert/criteoSpotLightAdvert";
import { getFeature } from "../../utils/features";
import config from "../../../common/CriteoAdvertsForRecs/config";
import { useFeaturesReady } from "../../context/featuresReady/FeaturesReadyContext";

const FALLBACK_PRICE = 1;

const AdvertBanner = () => {
  const { areFeaturesReady } = useFeaturesReady();
  const { advertsSdkInstance } = useAdverts();
  const { isStockStateReady, isInStock } = useIsInStockContext();
  const { products } = useStockPrice();
  const { previousBackInStockVariantId } = usePreviousBackInStock();

  const getSelectedOrOnlyVariantId = () => {
    const selectedVariant = getPreselectedVariant(
      products,
      previousBackInStockVariantId,
    );

    if (selectedVariant) {
      return selectedVariant.variantId;
    }

    const onlyVariant = getFirstVariant(products);

    if (onlyVariant) {
      return onlyVariant.variantId;
    }

    return;
  };

  if (!areFeaturesReady && !isStockStateReady) {
    return null;
  }

  const feature = getFeature(config.experimentKey);
  const bucket = feature?.isEnabled?.()
    ? feature?.getVariables?.()?.bucket
    : "v1";

  const GoogleAdvert = () => (
    <Advert
      sdkInstance={advertsSdkInstance}
      app={APP.PDP}
      placement={PLACEMENT.BOTTOM}
      requestSponsoredProducts={false}
      requestDisplayAdverts={true}
      parameters={{
        item: getSelectedOrOnlyVariantId(),
        "parent-item": products.id,
        price: FALLBACK_PRICE,
        "list-price": FALLBACK_PRICE,
        availability: Number(isInStock),
      }}
      rootMargin={"500px"}
    />
  );

  // v1 = Show Google Adverts
  // v2 = Show Criteo Advert
  // v3 = Show NO Advert

  return (
    <>
      {bucket === "v1" ? (
        <GoogleAdvert />
      ) : bucket === "v2" ? (
        <section className={styles.advertContainer}>
          <CriteoSpotLightAdvert />
        </section>
      ) : null}
    </>
  );
};

export default AdvertBanner;
